import { object, string } from 'yup';

import { createValidator } from '@src/validation';
import { textValidator } from '@src/validation/textValidator';
import { reportsStore } from '@stores/dictionaryStores/reports/reportsStore';

const validateSchema = object().shape({
  code: textValidator({ fieldName: 'code' })
    .test('code', 'Код должен быть уникальным', (value, { parent: { id } }) => {
      const { reports } = reportsStore;
      return !reports.some((report) => report.code === value && report.id !== id);
    })
    .required(),
  codeExt: textValidator({ fieldName: 'codeExt' }),
  reportGroupCode: string().nullable().trim().required(),
  reportTypeCode: string().nullable().trim().required(),
  name: textValidator({ fieldName: 'name' }),
});

export const validate = createValidator(validateSchema);
